'use client';
import { useEffect } from 'react';
import { useSatelliteContext } from '../components/SatelliteProvider';
import { type Auth0PageViewUrlParams } from '../lib/auth0/types';

export function useRegisterPageViewParams(pageViewParams: Auth0PageViewUrlParams | null) {
  const { segmentPageViewListenerAdded } = useSatelliteContext();

  useEffect(() => {
    if (pageViewParams && segmentPageViewListenerAdded) {
      const pageViewReadyEvent = new CustomEvent('segment-pageview-ready', {
        detail: pageViewParams,
      });
      document.dispatchEvent(pageViewReadyEvent);
    }
  }, [pageViewParams, segmentPageViewListenerAdded]);
}
